<div class="cpt-modal RevolutionImageSliderComponent">
  <div class="relative">
    <button
      class="absolute top-0 right-0 md:-top-5 md:-right-5 scale-150 w-6 h-6 outline-0 z-50"
      (click)="close()"
      >
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <div class="image-preview w-full h-full max-w-[calc(100%-100px)] max-h-[450px]  m-auto">
    @if (imageArr.length > 1) {
      <button
        class="image-slider-btn left-1 md:left-5 z-50"
        (click)="back()"
        >
        <mat-icon
          svgIcon="chevron_left"
          class="text-white text-4xl flex justify-center items-center w-10 md:w-14 h-10 md:h-14"
          >
        </mat-icon>
      </button>
    }
    @if (imageArr.length > 1) {
      <button
        class="image-slider-btn right-1 md:right-5 z-50"
        (click)="forward()"
        >
        <mat-icon
          svgIcon="chevron_right"
          class="text-white text-4xl flex justify-center items-center w-10 md:w-14 h-10 md:h-14"
          >
        </mat-icon>
      </button>
    }

    <div
      class="w-full h-full relative max-h-[calc(70vh-85px)] md:max-h-[calc(70vh-100px)] lg:max-h-[calc(70vh-170px)] pt-8 md:pt-4"
      >
      <div
        class="absolute -top-2 md:-top-7 right-0 z-10 p-1 w-10 h-10"
        >
        <customer-portal-app-vehicle-profile-picture
          [vehicle]="vehicle"
          [setPicture]="imageArr[index]"
          [showAlways]="true"
        ></customer-portal-app-vehicle-profile-picture>
      </div>
      <img
        #sliderImage
        class="w-full h-full"
        [src]="imageArr[index]?.publicUrl"
        alt=""
        />
    </div>

    <div
      class="hidden lg:flex justify-center absolute bottom-7 inset-x-10 gap-6 cursor-pointer"
      >
      <ngx-glide
        #RevolutionImageSliderComponent_ngxGlide
        [arrowLeftTemplate]="left"
        [arrowRightTemplate]="right"
        [startAt]="startAt || 0"
        [gap]="0"
        [peek]="{ before: 0, after: 70 }"
        (resized)="recreate()"
        [showBullets]="false"
        [showArrows]="showArrows"
        [perView]="maxSlides"
        [perTouch]="maxSlides"
        [bound]="boundAndFitGlider"
        [ngClass]="{ fitGlider: boundAndFitGlider }"
        class="max-w-full"
        >
        @for (img of imageArr; track $index) {
          <div
            class="image-preview flex flex-col min-w-[120px] max-w-[120px] relative px-1 border-mat-ef-revolution-grey-500 pb-2"
            (click)="setImage($index)"
            >
            <div class="absolute top-0 right-0 z-10 p-1 w-8 h-8">
              <customer-portal-app-vehicle-profile-picture
                [vehicle]="vehicle"
                [setPicture]="img"
              ></customer-portal-app-vehicle-profile-picture>
            </div>

            <img
              alt="vehicle img"
              class="vehicle-img rounded-lg flex-1 max-w-full bg-mat-ef-revolution-grey-500 h-20 max-h-[80px] pb-2"
              src="{{ img?.publicUrl }}"
              />
            @if (index === $index) {
              <div class="absolute bottom-0 left-0 right-0">
                <div
                  class="duration-600 ease-in-out h-0.5 mt-2 mx-auto transition-colors w-5/6 bg-mat-ef-revolution-secondary-500"
                ></div>
              </div>
            }
          </div>
        }
      </ngx-glide>
    </div>



    <div class="lg:hidden max-w-[calc(100vw-60px)] md:max-w-[calc(80vw-80px)] pt-6 pb-2 overflow-x-auto">
      <div class="flex justify-center space-x-2 w-full min-w-max">
        @for (img of imageArr; track $index) {
          <div
            [ngClass]="{
              'bg-mat-ef-revolution-secondary-500': index === $index,
              'bg-mat-ef-revolution-grey-700': index !== $index
            }"
            class="duration-600 ease-in transition-colors w-2 h-2 min-w-[8px] max-w-[8px] min-h-[8px] max-h-[8px] rounded-full cursor-pointer"
            (click)="setImage($index)"
          ></div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #left>
  <div
    class="hidden arrowTemplate small fill leftArrow md:flex justify-center items-center sideArrows !-left-3"
    >
    <mat-icon svgIcon="chevron_left"></mat-icon>
  </div>
</ng-template>

<ng-template #right>
  <div
    class="hidden arrowTemplate small fill rightArrow md:flex justify-center items-center sideArrows !-right-3"
    >
    <mat-icon svgIcon="chevron_right"></mat-icon>
  </div>
</ng-template>
